export const storeInLocalStorage = (response) => {
    window.localStorage.setItem("token", response.access_token)
    window.localStorage.setItem("userId", response.user_id)
    window.localStorage.setItem("email", response.email)
  }